import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { findIcon } from './constants';

interface ITooltipProps {
    toolTipMessage: string;
    variant?: 'success' | 'warning' | 'error' | 'info' | 'light';
}

const ToolTipAnchor = ({ toolTipMessage, variant = 'info' }: ITooltipProps) => {
    return (
        <>
            <span>&nbsp;</span>
            <FontAwesomeIcon
                icon={findIcon('fad', 'info-circle')}
                data-tooltip-html={toolTipMessage}
                data-tooltip-id={`tooltip-id-${variant}`}
            />
        </>
    );
};

export default ToolTipAnchor;
